import {
  getAssetContainerStatusIcon as coreGetAssetContainerStatusIcon,
  getAssetContainerStatusColor as coreGetAssetContainerStatusColor,
  getAssetContainerStateIcon as coreGetAssetContainerStateIcon
} from '@satellite/helpers/yardTaskUtils';
import { AssetContainerEventType, AssetContainerState } from '@nova/core';

import type { IAssetContainer, IAssetContainerEvent } from '@nova/core';

import type { WarehouseDetails, OrgDetails } from '@satellite/composables/useWarehousesPresenter';
import type { AppointmentDetails } from '@satellite/composables/appointmentPresenterShared';
import type { CarrierCompanyDetails } from '@satellite/composables/carrierPresenterShared';
import type { PresenterPlaceholderData } from './presenterPlaceholder';
import type { YardSpotAssignmentDetails } from '@satellite/composables/useYardSpotPresenter';
import type {
  YardAssetVisitDetails,
  YardAssetVisitEvent
} from '@satellite/composables/yardAssetVisitPresenterShared';

export interface YardAssetDetails extends Omit<IAssetContainer, 'createDateTime'> {
  createDateTime: string;
  state?: AssetContainerState | null;
  assetVisit?: YardAssetVisitDetails;
  assetVisitId?: string | null;
  spotAssignments?: YardSpotAssignmentDetails[];
  companyId?: string;
  pickupAppointmentId?: string;
  dropAppointmentId?: string;
  org?: OrgDetails;
  warehouse?: WarehouseDetails;
  pickupAppointment?: AppointmentDetails;
  dropAppointment?: AppointmentDetails;
  company?: CarrierCompanyDetails;
  assetVisitEvents?: YardAssetVisitEvent[];
  assetContainerEvents?: YardAssetContainerEvent[];
}

interface YardAssetContainerEvent extends IAssetContainerEvent {
  assetVisit?: YardAssetVisitDetails;
}

export type AssetContainerStatePresentationInput = YardAssetDetails | AssetContainerState | string;

export function getAssetContainerStatusIcon(status: AssetContainerEventType | string): string {
  return coreGetAssetContainerStatusIcon(status);
}

export function getAssetContainerStatusColor(
  status: AssetContainerEventType | string
): string | undefined {
  return coreGetAssetContainerStatusColor(status);
}

function resolveAssetContainerState(input: AssetContainerStatePresentationInput): string {
  if (typeof input === 'string') {
    return input;
  }

  return input?.state ?? '';
}

export function getAssetContainerStateIcon(state: AssetContainerState | string): string;
export function getAssetContainerStateIcon(asset: YardAssetDetails): string;
export function getAssetContainerStateIcon(
  assetOrState: AssetContainerStatePresentationInput
): string {
  const state = resolveAssetContainerState(assetOrState);

  return coreGetAssetContainerStateIcon(state);
}
